// Single source of truth for accent themes. Add a new theme by adding one entry here.
export const ACCENT_THEMES = [
  { id: "kaos-core", name: "KAOS Core", swatch: "#06b6d4", swatch2: "#2dd4bf" },
  { id: "neon-violet", name: "Neon Violet", swatch: "#d946ef", swatch2: "#a855f7" },
  { id: "ember", name: "Ember", swatch: "#f97316", swatch2: "#fbbf24" },
  { id: "matrix", name: "Matrix", swatch: "#22c55e", swatch2: "#a3e635" },
];

export const DEFAULT_THEME = "kaos-core";
